import React, { useRef } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { useSelector } from 'react-redux';
import ModalDialog from '../ui/modal-dialog.js';
import Form from '../ui/form.js';
var t = i18n.getFixedT(null, 'board-billboardView');
var gt = i18n.getFixedT(null, 'app');
var BillboardViewDetail = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot;

  var id = props.id,
      onClose = props.onClose,
      detailData = props.detailData;
  var form_ref = useRef(null);

  var handleClose = function handleClose() {
    onClose();
  };

  var handleDownloadPdf = function handleDownloadPdf(filePath) {
    fetch("".concat(contextRoot, "/fileServer").concat(filePath)).then(function (response) {
      return response.blob();
    }).then(function (blob) {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = filePath.split('/').pop();
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }).catch(function (error) {
      return console.error('Error downloading PDF:', error);
    });
  };

  var checkLinksIsExist = function checkLinksIsExist() {
    if (detailData.linkUrl1 || detailData.linkUrl2 || detailData.linkUrl3) return true;
    return false;
  };

  if (_.isEmpty(detailData.id)) return null;
  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-close'),
    handler: handleClose
  });

  var fields = {};

  _.set(fields, 'title', {
    label: t('lbl-title')
  });

  _.set(fields, 'type', {
    label: t('lbl-billboard-type')
  });

  _.set(fields, 'description', {
    label: t('lbl-description'),
    editor: null,
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        className: "preline"
      }, val);
    }
  });

  _.set(fields, 'beginTime', {
    label: t('lbl-beginTime')
  });

  if (checkLinksIsExist()) {
    _.set(fields, 'links', {
      label: t('dlg-links'),
      formatter: function formatter(val, row) {
        var links = [];

        var addLink = function addLink(urlKey, nameKey, defaultNameKey) {
          if (row[urlKey]) {
            var defaultName = links.length > 0 ? t(defaultNameKey) : t('dlg-link1');
            links.push({
              url: row[urlKey],
              name: row[nameKey] ? row[nameKey] : defaultName
            });
          }
        };

        addLink('linkUrl1', 'linkName1', 'dlg-link1');
        addLink('linkUrl2', 'linkName2', 'dlg-link2');
        addLink('linkUrl3', 'linkName3', 'dlg-link3');
        return /*#__PURE__*/React.createElement("div", {
          className: "links-url"
        }, links.map(function (el, index) {
          return /*#__PURE__*/React.createElement("a", {
            className: "link-item",
            href: el.url,
            key: el.url + index,
            target: "_blank"
          }, el.name);
        }));
      }
    });
  }

  if (detailData.pdfPath1) {
    _.set(fields, 'file', {
      label: t('dlg-file'),
      formatter: function formatter(val, row) {
        return /*#__PURE__*/React.createElement("a", {
          className: "download-link",
          onClick: function onClick() {
            return handleDownloadPdf(row.pdfPath1);
          }
        }, row.pdfPath1.split('/').pop());
      }
    });
  }

  _.set(fields, 'image', {
    label: '',
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, row.imagePath1 && /*#__PURE__*/React.createElement("img", {
        src: "".concat(contextRoot, "/fileServer").concat(row.imagePath1)
      }), row.imagePath2 && /*#__PURE__*/React.createElement("img", {
        src: "".concat(contextRoot, "/fileServer").concat(row.imagePath2)
      }), row.imagePath3 && /*#__PURE__*/React.createElement("img", {
        src: "".concat(contextRoot, "/fileServer").concat(row.imagePath3)
      }));
    }
  });

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: t('dlg-billboard-view-detail'),
    global: true,
    info: '' // infoClassName={cx({'c-error':error})}
    ,
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement(Form, {
    id: "".concat(id, "-form"),
    ref: form_ref,
    className: "pure-form-aligned",
    fieldClassName: "pure-control-group",
    fields: fields,
    onChange: function onChange() {},
    value: detailData
  }));
});
BillboardViewDetail.defaultProps = {
  id: 'g-board-billboard-view-detial'
};
BillboardViewDetail.propTypes = {
  id: PropTypes.string
};
export default BillboardViewDetail;